/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import update from "immutability-helper";
import * as moment from "moment";

import { Me } from "../../types/RootState";
import {
    isType,
    resetMe,
    setCustomer,
    setCustomerQuotation,
    setSynchronizedUserData,
    setUser,
    setUserData,
    setAdvisorsStats,
} from "../actions";

const initialState: Me = {
    user: null,
    userData: null,
    lastClientUpdateAt: null,
    lastServerSyncAt: null,
    userDataModificationsToSync: [],
};

update.extend("$auto", function(value, object) {
    return object ? update(object, value) : update({}, value);
});

export default function meReducer(state: Me = initialState, action): Me {
    if (isType(action, setUser)) {
        return {
            ...state,
            user: {
                ...action.payload,
                company: action.payload.company,
                manager: action.payload.manager,
                advisors: action.payload.advisors,
            },
            lastClientUpdateAt: moment().toISOString(),
        };
    } else if (isType(action, setUserData)) {
        return {
            ...state,
            userData: action.payload,
            lastClientUpdateAt: moment().toISOString(),
        };
    } else if (isType(action, setCustomer)) {
        const path = `customers.${action.payload.id}`;
        const userDataModificationsToSync = state.userDataModificationsToSync.filter((m) => m.path !== path).concat({
            at: moment().toISOString(),
            type: "update",
            path,
        });
        return update(state, {
            userData: {
                customers: {
                    $auto: {
                        $merge: {
                            [action.payload.id]: action.payload,
                        },
                    },
                },
            },
            userDataModificationsToSync: { $set: userDataModificationsToSync },
            lastClientUpdateAt: { $set: moment().toISOString() },
        });
    } else if (isType(action, setSynchronizedUserData)) {
        return {
            ...state,
            userData: action.payload.userData,
            lastServerSyncAt: moment().toISOString(),
            userDataModificationsToSync: state.userDataModificationsToSync.filter((m) =>
                moment(m.at).isAfter(action.payload.beforeTimestamp)
            ),
        };
    } else if (isType(action, setCustomerQuotation)) {
        const path = `customers.${action.payload.customerId}.quotations.${action.payload.quotation.id}`;
        const userDataModificationsToSync = state.userDataModificationsToSync.filter((m) => m.path !== path).concat({
            at: moment().toISOString(),
            type: "update",
            path,
        });
        return update(state, {
            userData: {
                customers: {
                    [action.payload.customerId]: {
                        quotations: {
                            $auto: {
                                $merge: {
                                    [action.payload.quotation.id]: action.payload.quotation,
                                },
                            },
                        },
                    },
                },
            },
            userDataModificationsToSync: { $set: userDataModificationsToSync },
            lastClientUpdateAt: { $set: moment().toISOString() },
        });
    } else if (isType(action, setAdvisorsStats)) {
        return {
            ...state,
            advisorsStats: action.payload
        };
    } else if (isType(action, resetMe)) {
        return {
            user: null,
            userData: null,
            lastServerSyncAt: null,
            lastClientUpdateAt: null,
            userDataModificationsToSync: [],
        };
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/me.reducer.ts